import { render, staticRenderFns } from "./knowledgeArticleSubject.vue?vue&type=template&id=021f3bd3&lang=pug"
import script from "./knowledgeArticleSubject.vue?vue&type=script&lang=js"
export * from "./knowledgeArticleSubject.vue?vue&type=script&lang=js"
import style0 from "./knowledgeArticleSubject.vue?vue&type=style&index=0&id=021f3bd3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports